import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import arcmIcons from '../Icons'
import Modal from '../components/core/Modal'
import { DatePicker, Tooltip } from 'antd'

const ExportOrders = ({
  onvVeiwChange,
  AdminSettings,
  saveAdminSettings,
  setAdminSettings,
  saveBtnLoading,
  ...props
}) => {
  const [expostModalLoading, setExpostModalLoading] = useState(false)
  const [isOpenExportModal, setIsOpenExportModal] = useState(false)
  const [exportError, setExportError] = useState(false)
  const [exportModalTitle, setExportModalTitle] = useState('Order Exporting')
  const { order_export_option } = AdminSettings

  const exportOrder = async () => {
    setIsOpenExportModal(true)
    setExpostModalLoading(true)

    try {
      // Build query parameters
      const queryParams = new URLSearchParams({
        export_format: order_export_option.export_format,
        export_file_name: order_export_option.export_file_name,
        order_start_date: order_export_option.order_start_date || '',
        order_end_date: order_export_option.order_end_date || '',
        sort_order: order_export_option.sort_order
      }).toString()

      // Make REST API request
      const response = await fetch(
        `${appObj.baseEndpoint}export-orders?${queryParams}`,
        {
          method: 'GET',
          headers: {
            'X-WP-Nonce': appObj.apiNonce
          }
        }
      )

      console.log(response)

      if (!response.ok) {
        setExpostModalLoading(false)
        setExportError(true)
        setExportModalTitle('Export failed. No orders found')
        return
      }

      // Get the blob from response
      const blob = await response.blob()

      // Create download link
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${formatFileName(
        order_export_option.export_file_name
      )}.${order_export_option.export_format}`
      link.click()

      setExpostModalLoading(false)
      setExportError(false)
      setExportModalTitle('Successfully order exported')
    } catch (error) {
      console.error('Export error:', error)
      setExportError(true)
      setExportModalTitle('Export failed')
    } finally {
      setExpostModalLoading(false)
    }
  }

  const formatFileName = fileName => {
    if (fileName.includes('%')) {
      const now = new Date()

      const formattedFilename = fileName
        .replace('%y', now.getFullYear())
        .replace('%m', String(now.getMonth() + 1).padStart(2, '0'))
        .replace('%d', String(now.getDate()).padStart(2, '0'))
        .replace('%h', String(now.getHours()).padStart(2, '0'))
        .replace('%s', String(now.getSeconds()).padStart(2, '0'))

      return formattedFilename
    }

    return fileName
  }

  const handleIsOpenExportModal = () => {
    setIsOpenExportModal(!isOpenExportModal)
  }

  useEffect(() => {
    if (exportError) {
      setExportModalTitle('Order export failed')
    } else {
      setExportModalTitle('Successfully order exported')
    }
  }, [setExportError])

  return (
    <>
      <div className='archive-export-orders'>
        <button
          onClick={() => onvVeiwChange('dashboard_settings')}
          className=' arcm-mb-4 arcm-flex arcm-items-center arcm-justify-center arcm-text-[#3858e9] arcm-text-sm arcm-font-semibold'
        >
          <div className='icon arcm-mr-2'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='8'
              height='14'
              viewBox='0 0 8 14'
              fill='none'
            >
              <path
                d='M7.125 13.25L0.875 7L7.125 0.75'
                stroke='#3858E9'
                stroke-width='1.5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
          </div>{' '}
          Go to Dashboard
        </button>
        <div className='archive-export-orders__form arcm-mt-8 md:arcm-mt-12'>
          <div className='arcm-title arcm-mb-6'>
            <h5 className='arcm-text-gray-800 arcm-text-xl arcm-font-bold arcm-mb-1.5'>
              Export Orders
            </h5>
            <p className='arcm-text-gray-500 arcm-text-sm arcm-font-normal'>
              Export your orders in a csv, json, xml or other popular formats
            </p>
          </div>

          <div className='arcm-form-group arcm-mb-6'>
            <label className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-3'>
              <span className='arcm-mr-2 arcm-align-[2px]'>
                Select the date range to export orders
              </span>
              <Tooltip
                className=' arcm-text-sm'
                placement='top'
                title='Archive Range'
                color='#fff'
              >
                <span className='icon arcm-inline-flex'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='13'
                    viewBox='0 0 14 13'
                    fill='none'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                      fill='#D1D5DB'
                    />
                  </svg>
                </span>
              </Tooltip>
            </label>
            <div className='arcm-select-fields arcm-max-w-[489px] arcm-flex arcm-flex-col sm:arcm-flex-row arcm-flex-wrap sm:arcm-items-center arcm-gap-3.5'>
              <div className='arcm-select-fields__date arcm-flex-grow'>
                <div className='arcm-label arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-1.5'>
                  From
                </div>
                <DatePicker
                  className='arcm-min-w-full !arcm-text-gray-900'
                  placeholder='Select Date'
                  defaultValue={
                    order_export_option.order_start_date
                      ? dayjs(
                          order_export_option.order_start_date,
                          'YYYY-MM-DD'
                        )
                      : ''
                  }
                  onChange={(date, dateString) => {
                    order_export_option.order_start_date = dateString
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
              </div>

              <div className='arcm-divider arcm-hidden sm:arcm-block arcm-text-black arcm-text-sm arcm-font-medium arcm-whitespace-nowrap arcm-mt-[20px]'>
                -
              </div>

              <div className='arcm-select-fields__date arcm-flex-grow'>
                <div className='arcm-label arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-1.5'>
                  To
                </div>
                <DatePicker
                  className='arcm-min-w-full !arcm-text-gray-900'
                  placeholder='Select Date'
                  defaultValue={
                    order_export_option.order_end_date
                      ? dayjs(order_export_option.order_end_date, 'YYYY-MM-DD')
                      : ''
                  }
                  onChange={(date, dateString) => {
                    order_export_option.order_end_date = dateString
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
              </div>
            </div>
            <p className='arcm-text-gray-600 arcm-text-xs arcm-font-normal arcm-mt-3'>
              If no date range is selected, all the orders till today will be
              exported **
            </p>
          </div>
          <div className='arcm-form-group arcm-mb-6'>
            <label className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-3'>
              <span className='arcm-mr-2 arcm-align-[2px]'>
                Exported file name
              </span>
              <Tooltip
                className=' arcm-text-sm'
                placement='top'
                title='Archive Range'
                color='#fff'
              >
                <span className='icon arcm-inline-flex'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='13'
                    viewBox='0 0 14 13'
                    fill='none'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                      fill='#D1D5DB'
                    />
                  </svg>
                </span>
              </Tooltip>
            </label>
            <input
              type='text'
              value={order_export_option.export_file_name}
              className='arcm-max-w-[489px] !arcm-p-4 !arcm-bg-white !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-900 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-full'
              onChange={e => {
                order_export_option.export_file_name = e.target.value
                setAdminSettings({
                  ...AdminSettings,
                  order_export_option: order_export_option
                })
              }}
            />
          </div>
          <div className='arcm-form-group arcm-mb-6'>
            <label className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-3'>
              <span className='arcm-mr-2 arcm-align-[2px]'>Sort orders</span>
              <Tooltip
                className=' arcm-text-sm'
                placement='top'
                title='Archive Range'
                color='#fff'
              >
                <span className='icon arcm-inline-flex'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='13'
                    viewBox='0 0 14 13'
                    fill='none'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                      fill='#D1D5DB'
                    />
                  </svg>
                </span>
              </Tooltip>
            </label>

            <div className='arcm-radio-fields arcm-flex arcm-flex-wrap arcm-items-center arcm-gap-4 arcm-max-w-[332px]'>
              <label
                for='arcm-ascending'
                className=" arcm-grow arcm-shrink arcm-basis-[158px] arcm-radio arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-p-5 arcm-pl-[52px] arcm-bg-white arcm-rounded-lg arcm-relative arcm-min-w-[158px] arcm-items-center arcm-inline-flex arcm-cursor-pointer after:arcm-content-[''] after:arcm-w-5 after:arcm-h-5 after:arcm-border after:arcm-rounded-full after:arcm-border-gray-400 after:arcm-absolute after:arcm-left-6 before:arcm-content-[''] before:arcm-w-3 before:arcm-h-3 before:arcm-rounded-full before:arcm-bg-transparent before:arcm-absolute before:arcm-left-7 arcm-transition-all has-[:checked]:before:arcm-bg-[#3858e9] has-[:checked]:after:arcm-border-[#3858e9]"
              >
                <input
                  type='radio'
                  id='arcm-ascending'
                  className='!arcm-hidden'
                  name='sort-orders'
                  value='ASC'
                  checked={order_export_option.sort_order == 'ASC'}
                  onChange={e => {
                    order_export_option.sort_order = e.target.value
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
                <span>Ascending</span>
              </label>

              <label
                for='arcm-descending'
                className=" arcm-grow arcm-shrink arcm-basis-[158px] arcm-radio arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-p-5 arcm-pl-[52px] arcm-bg-white arcm-rounded-lg arcm-relative arcm-min-w-[158px] arcm-items-center arcm-inline-flex arcm-cursor-pointer after:arcm-content-[''] after:arcm-w-5 after:arcm-h-5 after:arcm-border after:arcm-rounded-full after:arcm-border-gray-400 after:arcm-absolute after:arcm-left-6 before:arcm-content-[''] before:arcm-w-3 before:arcm-h-3 before:arcm-rounded-full before:arcm-bg-transparent before:arcm-absolute before:arcm-left-7 arcm-transition-all has-[:checked]:before:arcm-bg-[#3858e9] has-[:checked]:after:arcm-border-[#3858e9]"
              >
                <input
                  type='radio'
                  id='arcm-descending'
                  name='sort-orders'
                  className='!arcm-hidden'
                  value='DESC'
                  checked={order_export_option.sort_order == 'DESC'}
                  onChange={e => {
                    order_export_option.sort_order = e.target.value
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
                <span>Descending</span>
              </label>
            </div>
          </div>

          <div className='arcm-form-group arcm-mb-4'>
            <label className='arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-block arcm-mb-3'>
              <span className='arcm-mr-2 arcm-align-[2px]'>
                Select the export format
              </span>
              <Tooltip
                className=' arcm-text-sm'
                placement='top'
                title='Archive Range'
                color='#fff'
              >
                <span className='icon arcm-inline-flex'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='13'
                    viewBox='0 0 14 13'
                    fill='none'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M13.4001 6.49998C13.4001 10.0346 10.5347 12.9 7.0001 12.9C3.46548 12.9 0.600098 10.0346 0.600098 6.49998C0.600098 2.96535 3.46548 0.0999756 7.0001 0.0999756C10.5347 0.0999756 13.4001 2.96535 13.4001 6.49998ZM6.15157 4.05143C5.91725 4.28574 5.53736 4.28574 5.30304 4.05143C5.06873 3.81711 5.06873 3.43721 5.30304 3.2029C6.2403 2.26564 7.75989 2.26564 8.69715 3.2029C9.63441 4.14016 9.63441 5.65975 8.69715 6.59701C8.38317 6.911 8.00238 7.12048 7.6001 7.22404V7.49995C7.6001 7.83132 7.33147 8.09995 7.0001 8.09995C6.66873 8.09995 6.4001 7.83132 6.4001 7.49995V7.09995C6.4001 6.52372 6.85605 6.16258 7.26517 6.07055C7.47868 6.02252 7.68138 5.91573 7.84863 5.74848C8.31725 5.27985 8.31725 4.52006 7.84863 4.05143C7.38 3.5828 6.6202 3.5828 6.15157 4.05143ZM7.0001 10.5C7.44192 10.5 7.8001 10.1418 7.8001 9.69998C7.8001 9.25815 7.44192 8.89997 7.0001 8.89997C6.55827 8.89997 6.2001 9.25815 6.2001 9.69998C6.2001 10.1418 6.55827 10.5 7.0001 10.5Z'
                      fill='#D1D5DB'
                    />
                  </svg>
                </span>
              </Tooltip>
            </label>

            <div className='arcm-radio-fields arcm-flex arcm-flex-wrap arcm-items-center arcm-gap-4 arcm-max-w-[680px]'>
              <label
                for='arcm-csv'
                className=" arcm-grow arcm-shrink arcm-basis-[158px] arcm-radio arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-p-5 arcm-pl-[52px] arcm-bg-white arcm-rounded-lg arcm-relative arcm-min-w-[158px] arcm-items-center arcm-inline-flex arcm-cursor-pointer after:arcm-content-[''] after:arcm-w-5 after:arcm-h-5 after:arcm-border after:arcm-rounded-full after:arcm-border-gray-400 after:arcm-absolute after:arcm-left-6 before:arcm-content-[''] before:arcm-w-3 before:arcm-h-3 before:arcm-rounded-full before:arcm-bg-transparent before:arcm-absolute before:arcm-left-7 arcm-transition-all has-[:checked]:before:arcm-bg-[#3858e9] has-[:checked]:after:arcm-border-[#3858e9]"
              >
                <input
                  type='radio'
                  id='arcm-csv'
                  name='export-format'
                  className='!arcm-hidden'
                  value='csv'
                  checked={order_export_option.export_format == 'csv'}
                  onChange={e => {
                    order_export_option.export_format = e.target.value
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
                <span>CSV</span>
              </label>

              <label
                for='arcm-json'
                className=" arcm-grow arcm-shrink arcm-basis-[158px] arcm-radio arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-p-5 arcm-pl-[52px] arcm-bg-white arcm-rounded-lg arcm-relative arcm-min-w-[158px] arcm-items-center arcm-inline-flex arcm-cursor-pointer after:arcm-content-[''] after:arcm-w-5 after:arcm-h-5 after:arcm-border after:arcm-rounded-full after:arcm-border-gray-400 after:arcm-absolute after:arcm-left-6 before:arcm-content-[''] before:arcm-w-3 before:arcm-h-3 before:arcm-rounded-full before:arcm-bg-transparent before:arcm-absolute before:arcm-left-7 arcm-transition-all has-[:checked]:before:arcm-bg-[#3858e9] has-[:checked]:after:arcm-border-[#3858e9]"
              >
                <input
                  type='radio'
                  id='arcm-json'
                  name='export-format'
                  className='!arcm-hidden'
                  value='json'
                  checked={order_export_option.export_format == 'json'}
                  onChange={e => {
                    order_export_option.export_format = e.target.value
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
                <span>JSON</span>
              </label>

              <label
                for='arcm-xml'
                className=" arcm-grow arcm-shrink arcm-basis-[158px] arcm-radio arcm-text-gray-900 arcm-text-sm arcm-font-medium arcm-p-5 arcm-pl-[52px] arcm-bg-white arcm-rounded-lg arcm-relative arcm-min-w-[158px] arcm-items-center arcm-inline-flex arcm-cursor-pointer after:arcm-content-[''] after:arcm-w-5 after:arcm-h-5 after:arcm-border after:arcm-rounded-full after:arcm-border-gray-400 after:arcm-absolute after:arcm-left-6 before:arcm-content-[''] before:arcm-w-3 before:arcm-h-3 before:arcm-rounded-full before:arcm-bg-transparent before:arcm-absolute before:arcm-left-7 arcm-transition-all has-[:checked]:before:arcm-bg-[#3858e9] has-[:checked]:after:arcm-border-[#3858e9]"
              >
                <input
                  type='radio'
                  id='arcm-xml'
                  name='export-format'
                  className='!arcm-hidden'
                  value='xml'
                  checked={order_export_option.export_format == 'xml'}
                  onChange={e => {
                    order_export_option.export_format = e.target.value
                    setAdminSettings({
                      ...AdminSettings,
                      order_export_option: order_export_option
                    })
                  }}
                />
                <span>XML</span>
              </label>
            </div>
          </div>

          <button
            onClick={exportOrder}
            class='arcm-text-white arcm-text-xs sm:arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-border arcm-border-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all arcm-group arcm-bg-[#3858e9] hover:arcm-bg-white hover:arcm-text-[#3858e9]'
          >
            <span className='icon'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <path
                  className='arcm-transition-all group-hover:arcm-stroke-[#3858E9]'
                  d='M1.5 12.75V14.625C1.5 15.6605 2.33947 16.5 3.375 16.5H14.625C15.6605 16.5 16.5 15.6605 16.5 14.625V12.75M12.75 9L9 12.75M9 12.75L5.25 9M9 12.75V1.5'
                  stroke='#ffffff'
                  stroke-width='1.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
            </span>
            <span>Export Orders</span>
          </button>
        </div>
      </div>
      <Modal
        openModal={isOpenExportModal}
        toggleModal={handleIsOpenExportModal}
        outerClick={false}
      >
        {{
          body: expostModalLoading ? (
            <div className='arcm-text-center arcm-mb-6'>
              <div className='icon arcm-inline-flex'>
                {arcmIcons.SpinningAnimation}
              </div>
              <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                Exporting Order
              </h5>
            </div>
          ) : (
            <div className='arcm-text-center arcm-my-6'>
              {exportError ? (
                <>
                  <div className='icon arcm-inline-flex arcm-mb-6'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      x='0px'
                      y='0px'
                      width='100'
                      height='100'
                      viewBox='0 0 48 48'
                    >
                      <path
                        fill='#f44336'
                        d='M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z'
                      ></path>
                      <path
                        fill='#fff'
                        d='M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z'
                      ></path>
                      <path
                        fill='#fff'
                        d='M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z'
                      ></path>
                    </svg>
                  </div>
                  <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                    {exportModalTitle}
                  </h5>
                  <button
                    onClick={handleIsOpenExportModal}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-min-w-[120px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    <span>Ok</span>
                  </button>
                </>
              ) : (
                <>
                  <div className='icon arcm-inline-flex arcm-mb-6'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='60'
                      height='60'
                      viewBox='0 0 60 60'
                      fill='none'
                    >
                      <path
                        d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                        fill='#27D935'
                      />
                      <path
                        d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                        fill='#27D935'
                      />
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M14.5801 31.414L24.5801 41.414C25.3601 42.196 26.6281 42.196 27.4081 41.414L45.4081 23.414C46.1881 22.634 46.1881 21.366 45.4081 20.586C44.6281 19.806 43.3601 19.806 42.5801 20.586L25.9941 37.172L17.4081 28.586C16.6281 27.806 15.3601 27.806 14.5801 28.586C13.8001 29.366 13.8001 30.634 14.5801 31.414Z'
                        fill='white'
                      />
                    </svg>
                  </div>
                  <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                    {exportModalTitle}
                  </h5>
                  <button
                    onClick={handleIsOpenExportModal}
                    className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-min-w-[120px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
                  >
                    <span>Ok</span>
                  </button>
                </>
              )}
            </div>
          )
        }}
      </Modal>
    </>
  )
}

export default ExportOrders
